import Text from 'components/base/Text';
import { LINE_HEIGHT, SIZES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import { Flex } from 'components/base/layout-components';
import Loading from 'images/blue_loading_transparent.gif';
import styled from 'styled-components';
import { LBButton } from '@linearb/buzz';

const Loader = styled.img`
  width: 5rem;
`;

const StyledFlex = styled(Flex)`
  left: 0;
  right: 0;
`;

const OverlayWrapper = ({ children, dataTestId }) => (
  <StyledFlex
    direction='column'
    ml='auto'
    mr='auto'
    width='18rem'
    padding='small'
    position='absolute'
    backgroundColor={getColor('titanWhite')}
    style={{ zIndex: 10 }}
    mt='large'
    data-testid={dataTestId}
  >
    {children}
  </StyledFlex>
);

export const PulseIterationPickerLoadIterationsOverlay = ({
  onLoadIterations
}) => {
  return (
    <OverlayWrapper dataTestId={'load-iteration-overlay'}>
      <Text
        color={'shuttleGray'}
        size='medium'
        pb={SIZES.medium}
        lineHeight={LINE_HEIGHT.medium}
      >
        Past iterations might take some time to load. Check out the current
        iteration for now
      </Text>
      <Flex>
        <LBButton
          variant='outline'
          onClick={onLoadIterations}
          data-testid='load-iterations-button'
        >
          <Icon size='x-small' name='refresh' color='chambray' /> Load past
          iterations
        </LBButton>
      </Flex>
    </OverlayWrapper>
  );
};

export const PulseIterationPickerLoadingOverlay = () => {
  return (
    <OverlayWrapper dataTestId={'iterations-loading-overlay'}>
      <Flex pb='small' pt='small' justify='center'>
        <Loader src={Loading} />
      </Flex>
      <Text
        color={'shuttleGray'}
        size='medium'
        align='center'
        lineHeight={LINE_HEIGHT.medium}
        pb='1rem'
      >
        Loading past iterations.
        <br />
        Check back later
      </Text>
    </OverlayWrapper>
  );
};
